<template>
  <div style="width: 100%">
    <v-dialog v-model="confirmDialog" max-width="350">
      <v-card class="card-container text-center pa-6">
        <h3>Confirmação</h3>

        <v-divider class="mt-3"></v-divider>

        <p style="color: grey" class="mt-3">
          Todos os dados alterados só serão aplicados as Ordens de Serviço
          adicionadas a partir desta atualização!
        </p>
        <strong>Tem certeza de que deseja prosseguir?</strong>
        <div class="d-flex justify-center mt-4">
          <v-btn
            small
            depressed
            class="quaternary-button ma-1"
            color="#B14949"
            @click="confirmDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            small
            :loading="loading"
            depressed
            color="#426483"
            class="ma-1 primary-button"
            @click="submit"
          >
            Confirmar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-card class="card-pad d-flex align-center mb-4" height="75" width="100%">
      <v-btn
        depressed
        small
        text
        color="grey"
        @click="back"
        style="position: absolute; left: 15px"
      >
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
      <v-spacer></v-spacer>
      <strong>Automação</strong>
      <v-spacer></v-spacer>
    </v-card>

    <v-form ref="form" @submit.prevent>
      <v-card
        v-if="automation.id"
        class="card-container white--text py-4"
        width="100%"
        :color="automation.active ? 'success' : 'error'"
      >
        <span>Status: </span>
        <strong>{{ automation.active ? 'Ativo' : 'Inativo' }}</strong>
      </v-card>

      <v-card class="card-container mt-4" width="100%">
        <div>
          <strong>Dados da Automação</strong>
          <v-divider class="my-4"></v-divider>

          <v-row class="ma-0" dense>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Nome</label>
              <v-text-field
                v-model="automation.name"
                hide-details="auto"
                :rules="[(v) => !!v || 'Unidade obrigatório']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <label class="label ml-1">Abertura baseada em</label>
              <v-select
                v-model="automation.openBasedOn"
                single-line
                append-icon="mdi-chevron-down"
                :items="openBasedOnOptions"
                item-text="text"
                item-value="value"
                :rules="[(v) => v != null || 'Unidade obrigatório']"
                hide-details
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4">
              <label class="label ml-1">Repetição</label>
              <v-select
                single-line
                v-model="automation.repeatPeriod"
                append-icon="mdi-chevron-down"
                :items="repeatPeriodOptions"
                item-text="text"
                :rules="[(v) => v != null || 'Unidade obrigatório']"
                item-value="value"
                hide-details
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-select>
            </v-col>

            <v-col>
              <label class="label ml-1">Válido em fins de semana</label>
              <v-select
                v-model="automation.validOnWeekends"
                :items="boolOptions"
                item-text="text"
                item-value="value"
                single-line
                :rules="[(v) => v != null || 'Unidade obrigatório']"
                append-icon="mdi-chevron-down"
                hide-details
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-select>
            </v-col>

            <v-col>
              <label class="label ml-1">Válido em feriados</label>
              <v-select
                v-model="automation.validOnHolidays"
                :items="boolOptions"
                item-text="text"
                item-value="value"
                :rules="[(v) => v != null || 'Unidade obrigatório']"
                single-line
                append-icon="mdi-chevron-down"
                hide-details
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-select>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-card class="card-container mt-4" width="100%">
        <div>
          <div class="d-flex align-center">
            <strong>Modelo de Ordem de Serviço</strong>

            <v-spacer></v-spacer>

            <v-checkbox
              v-model="automation.isExternal"
              class="my-2 mr-2"
              hide-details
              label="Externa"
              color="#BBCF20"
            ></v-checkbox>
          </div>

          <v-divider class="my-2"></v-divider>

          <v-row class="ma-0" dense>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Instituição</label>
              <v-text-field
                v-model="institution.name"
                single-line
                placeholder="Selecione"
                hide-details="auto"
                outlined
                readonly
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Categoria</label>
              <v-select
                v-model="automation.category"
                single-line
                :items="categories"
                @change="getDepartments"
                item-text="text"
                item-value="value"
                append-icon="mdi-chevron-down"
                hide-details="auto"
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Nome O.S.</label>
              <v-text-field
                v-model="automation.nameOS"
                hide-details="auto"
                :rules="[(v) => !!v || 'Nome obrigatório']"
                outlined
                class="primary-input"
                hint="O nome será usado em todas as O.S. geradas a partir desta automação"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Solicitante</label>
              <v-text-field
                v-model="automation.requester"
                :rules="[(v) => !!v || 'Solicitante obrigatório']"
                hide-details="auto"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" v-if="institution.workshopType == 1">
              <label class="label ml-1">{{ $t('Oficina') }}</label>
              <v-autocomplete
                append-icon="mdi-chevron-down"
                hide-details="auto"
                :loading="workshopLoading"
                v-model="automation.workshopId"
                :items="workshopTypes"
                :rules="[(v) => v != null || 'Oficina obrigatório']"
                item-text="name"
                item-value="id"
                autocomplete="off"
                outlined
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Tipo O.S.</label>
              <v-autocomplete
                v-model="automation.serviceOrderType"
                append-icon="mdi-chevron-down"
                single-line
                :items="serviceOrderTypes"
                item-text="text"
                :rules="[(v) => !!v || 'Tipo obrigatório']"
                item-valute="value"
                hide-details="auto"
                placeholder="Selecione"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Responsável</label>
              <v-autocomplete
                :loading="responsibleLoading"
                single-line
                append-icon="mdi-chevron-down"
                hide-details="auto"
                v-model="automation.responsibleName"
                item-text="name"
                item-value="name"
                placeholder="Selecione"
                :rules="
                  institution.userType < 2
                    ? [(v) => !!v || $t('Responsável obrigatório')]
                    : []
                "
                :items="responsibleUsers"
                outlined
                class="primary-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="label ml-1">Data de Solicitação</label>

              <date-picker
                ref="datepicker"
                style="width: 100%"
                mode="dateTime"
                v-model="automation.requestDate"
                is24hr
                :popover="{ visibility: 'click' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :class="
                      requestDateTimeError ? 'date-input-error' : 'date-input'
                    "
                    :value="inputValue"
                    v-on="inputEvents"
                    v-mask="['##/##/#### ##:##']"
                    @focus="setRequestNowDate"
                  />
                  <span class="date-span-error" v-if="requestDateTimeError">
                    {{ $t('Data da solicitação é requerida') }}
                  </span>
                </template>
              </date-picker>
            </v-col>
            <v-col cols="12">
              <label class="label ml-1">Solicitação / Reclamação</label>
              <v-textarea
                v-model="automation.request"
                :rules="[(v) => !!v || 'Solicitação obrigatório']"
                hide-details="auto"
                placeholder="Descreva sua solicitação / reclamação"
                outlined
                class="primary-input"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <div class="mt-4">
        <v-expand-transition>
          <div v-if="automation.category == 0">
            <v-card class="card-container" width="100%">
              <strong>Equipamento</strong>
              <v-divider class="my-4"></v-divider>

              <v-row class="ma-0" dense>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Identificação</label>
                  <v-autocomplete
                    append-icon=""
                    ref="equip"
                    v-model="automation.equipmentId"
                    :items="equipmentsFiltered"
                    item-text="identification"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    item-value="id"
                    :loading="equipmentLoading"
                    :search-input.sync="searchEquipment"
                    @blur="searchEquipment = ''"
                    hide-details="auto"
                    placeholder="Digite uma identificação"
                    outlined
                    class="primary-input"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ item.identification }} / {{ item.name }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Código patrimônio</label>
                  <v-autocomplete
                    append-icon=""
                    v-model="automation.equipmentId"
                    :items="equipmentsFiltered"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    item-text="propertyCode"
                    item-value="id"
                    :loading="equipmentLoading"
                    :search-input.sync="searchEquipmentPropertyCode"
                    @blur="searchEquipmentPropertyCode = ''"
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    outlined
                    class="primary-input"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Unidade</label>
                  <v-autocomplete
                    v-model="automation.unidadeId"
                    :loading="unidadeLoading"
                    :items="unidades"
                    @change="getDepartments"
                    :rules="[(v) => !!v || 'Unidade obrigatório']"
                    item-text="name"
                    item-value="id"
                    :disabled="automation.category == 0"
                    single-line
                    append-icon="mdi-chevron-down"
                    hide-details="auto"
                    placeholder="Selecione"
                    outlined
                    class="primary-input"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Setor</label>
                  <v-text-field
                    :value="
                      selectedEquipment.department
                        ? selectedEquipment.department.name
                        : ''
                    "
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Sub-setor</label>
                  <v-text-field
                    single-line
                    :value="
                      selectedEquipment.subDepartment
                        ? selectedEquipment.subDepartment.name
                        : ''
                    "
                    hide-details="auto"
                    append-icon="mdi-chevron-down"
                    placeholder="Selecione um equipamento"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Centro de custo</label>
                  <v-text-field
                    :value="
                      selectedEquipment.costCenter
                        ? selectedEquipment.costCenter.name
                        : ''
                    "
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Equipamento</label>
                  <v-text-field
                    v-model="selectedEquipment.name"
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <label class="label ml-1">Fabricante</label>
                  <v-text-field
                    v-model="selectedEquipment.manufacturer"
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <label class="label ml-1">Modelo</label>
                  <v-text-field
                    v-model="selectedEquipment.model"
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    outlined
                    readonly
                    class="primary-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <label class="label ml-1">Nº série</label>
                  <v-autocomplete
                    v-model="automation.equipmentId"
                    :items="equipmentsFiltered"
                    item-text="serialNumber"
                    item-value="id"
                    :loading="equipmentLoading"
                    append-icon="mdi-chevron-down"
                    :search-input.sync="searchEquipmentSerial"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    @blur="searchEquipmentSerial = ''"
                    single-line
                    hide-details="auto"
                    placeholder="Selecione um equipamento"
                    outlined
                    class="primary-input"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>

                    <template v-slot:item="{ item }">
                      <span class="text-caption">
                        {{ item.serialNumber }} / {{ item.name }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-expand-transition>

        <v-expand-transition>
          <div v-if="automation.category == 1">
            <v-card class="card-container mt-4" width="100%">
              <strong>Setor</strong>
              <span class="mx-2 error--text" v-if="!automation.unidadeId">
                (Selecione uma unidade para prosseguir com a escolha do setor!)
              </span>
              <v-divider class="my-4"></v-divider>

              <v-row class="ma-0" dense>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Unidade</label>
                  <v-autocomplete
                    v-model="automation.unidadeId"
                    :loading="unidadeLoading"
                    :items="unidades"
                    @change="getDepartments"
                    :rules="[(v) => !!v || 'Unidade obrigatório']"
                    item-text="name"
                    item-value="id"
                    :disabled="automation.category == 0"
                    single-line
                    append-icon="mdi-chevron-down"
                    hide-details="auto"
                    placeholder="Selecione"
                    outlined
                    class="primary-input"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Setor</label>
                  <v-autocomplete
                    :items="departments"
                    :loading="departmentLoading"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v || 'Equipamento obrigatório']"
                    v-model="automation.departmentId"
                    append-icon="mdi-chevron-down"
                    single-line
                    hide-details="auto"
                    placeholder="Selecione um setor"
                    outlined
                    class="primary-input"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Sub-Setor</label>
                  <v-select
                    v-model="automation.subDepartmentId"
                    :loading="departmentLoading"
                    :items="subDepartments"
                    item-text="name"
                    item-value="id"
                    append-icon="mdi-chevron-down"
                    single-line
                    hide-details="auto"
                    placeholder="Selecione um sub-setor"
                    outlined
                    class="primary-input"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <label class="label ml-1">Localização</label>
                  <v-text-field
                    v-model="automation.location"
                    hide-details="auto"
                    :rules="[
                      (v) =>
                        v == null ||
                        v.length <= 64 ||
                        'Máximo de 64 caracteres',
                    ]"
                    outlined
                    class="primary-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-expand-transition>
      </div>

      <div class="d-flex align-center mt-4">
        <v-expand-transition>
          <div v-if="!loading">
            <v-btn
              small
              depressed
              class="quaternary-button ma-1"
              color="#B14949"
              @click="back"
            >
              Cancelar
            </v-btn>
          </div>
        </v-expand-transition>

        <v-spacer></v-spacer>

        <v-btn
          v-if="editing"
          :loading="loading"
          depressed
          color="#426483"
          class="ma-1 primary-button"
          @click="confirmDialog = true"
        >
          Atualizar
        </v-btn>

        <v-btn
          v-else
          :loading="loading"
          depressed
          color="#426483"
          class="ma-1 primary-button"
          @click="submit"
        >
          Adicionar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import moment from 'moment'

export default {
  name: 'ManageOrderAutomation',

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    await Promise.all([
      this.getUsersByType(),
      this.getUnidades(),
      this.getWorkshops(),
      this.getEquipments(),
      this.getDepartments(),
    ])

    const id = this.$route.query.id
    if (id) {
      this.editing = true
      this.getAutomation(id)
    }
  },

  data() {
    return {
      confirmDialog: false,
      loading: false,
      workshopTypes: [
        { text: 'Engenharia Clínica', value: 0 },
        { text: 'Carpintaria', value: 1 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
      responsibleLoading: false,
      institution: {},
      responsibleUsers: [],
      serviceOrderTypes: [
        // {
        //   text: 'Treinamento',
        //   value: 0,
        // },
        // {
        //   text: 'Segurança Elétrica',
        //   value: 1,
        // },
        // {
        //   text: 'Manutenção preventiva',
        //   value: 2,
        // },
        // {
        //   text: 'Instalação',
        //   value: 3,
        // },
        {
          text: 'Inspeção de Rotina',
          value: 4,
        },
        // {
        //   text: 'Corretiva',
        //   value: 5,
        // },
        // {
        //   text: 'Calibração',
        //   value: 6,
        // },
        // {
        //   text: 'Validação / Qualificação',
        //   value: 7,
        // },
        // {
        //   text: 'Serviços Administrativos',
        //   value: 8,
        // },
        // {
        //   text: 'Empréstimo',
        //   value: 9,
        // },
      ],
      user: {},
      requestDateTimeError: false,
      automation: {
        name: '',
        isExternal: false,
        openBasedOn: null,
        repeatPeriod: null,
        validOnWeekends: null,
        validOnHolidays: null,
        unidadeId: null,
        nameOS: '',
        requester: '',
        request: '',
        serviceOrderType: 4,
        equipmentId: null,
        departmentId: null,
        subDepartmentId: null,
        active: true,
        location: '',
        requestDate: null,
        category: 0,
        responsibleName: '',
        workshopId: null,
      },
      openBasedOnOptions: [
        {
          text: 'Data de solicitação',
          value: 0,
        },
        {
          text: 'Data de fechamento',
          value: 1,
        },
      ],
      repeatPeriodOptions: [
        {
          text: 'Diária',
          value: 0,
        },
        {
          text: 'Semanal',
          value: 1,
        },
        {
          text: 'Quinzenal',
          value: 2,
        },
        {
          text: 'Mensal',
          value: 3,
        },
      ],
      categories: [
        {
          text: 'Equipamento',
          value: 0,
        },
        {
          text: 'Setor',
          value: 1,
        },
      ],
      boolOptions: [
        {
          text: 'Sim',
          value: true,
        },
        {
          text: 'Não',
          value: false,
        },
      ],
      selectedEquipment: {},
      searchEquipmentSerial: '',
      searchEquipment: null,
      searchEquipmentPropertyCode: null,
      equipments: [],
      equipmentsFiltered: [],
      equipmentLoading: false,
      unidadeLoading: false,
      workshopLoading: false,
      unidades: [],
      apiService: new ApiService(),
      departmentLoading: false,
      departments: [],
      editing: false,
    }
  },

  computed: {
    subDepartments() {
      const department = this.departments.find(
        (x) =>
          x.id == this.automation.departmentId ||
          (this.selectedEquipment &&
            x.id == this.selectedEquipment.departmentId)
      )
      return department ? department.subDepartments : []
    },
  },

  methods: {
    getAutomation(id) {
      this.loading = true
      this.apiService
        .get('orderAutomation/' + id)
        .then((response) => {
          this.automation = { ...this.automation, ...response.content }
          this.getEquipmentById()
          this.getDepartments()
          this.equipmentsFiltered = this.equipments
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async getDepartments() {
      if (!this.automation || !this.automation.unidadeId) return

      this.departmentLoading = true
      await this.apiService
        .get(
          `department/list/unidade/${this.automation.unidadeId}`,
          null,
          true,
          false
        )
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async querySelectionsEquipment(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.identification.indexOf(value) > -1
        })

        this.equipmentLoading = false
        this.getEquipmentById()
      }, 500)
    },

    async querySelectionsEquipments(value) {
      this.equipmentLoading = true

      this.equipmentsFiltered = this.equipments.filter((e) => {
        if (e.propertyCode != null) {
          return e.propertyCode.indexOf(value) > -1
        }
      })

      this.equipmentLoading = false
      this.getEquipmentById()
    },

    async querySelectionsEquipmentSerial(value) {
      this.equipmentLoading = true

      setTimeout(() => {
        this.equipmentsFiltered = this.equipments.filter((e) => {
          return e.serialNumber && e.serialNumber.indexOf(value) > -1
        })

        this.equipmentLoading = false
        this.getEquipmentById()
      }, 500)
    },

    async getEquipmentById() {
      if (this.automation.equipmentId) {
        await this.apiService
          .get(
            `equipment/${this.institution.id}/${this.automation.equipmentId}`,
            null,
            true,
            false
          )
          .then(async (response) => {
            this.selectedEquipment = response.content
            this.automation.unidadeId = response.content.unidadeId
            this.automation.departmentId = response.content.departmentId
            this.automation.subDepartmentId = response.content.subDepartmentId
          })
      }
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/general/${this.institution.id}`, null, true, false)
        .then((response) => {
          this.equipments = response.content
          this.equipmentLoading = false
        })
        .catch(() => {
          this.equipmentLoading = false
        })
    },

    async getWorkshops() {
      this.workshopLoading = true
      await this.apiService
        .get('workshop/' + this.institution.id, true, false)
        .then((response) => {
          this.workshopTypes = response.content
          this.workshopLoading = false
        })
        .catch(() => {
          this.workshopLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      if (this.institution.userType > 1) {
        await this.apiService
          .get(
            `unidade/listByUserAndInstitution/${this.institution.id}`,
            true,
            false
          )
          .then((response) => {
            this.unidades = response.content
            this.unidadeLoading = false
          })
          .catch(() => {
            this.unidadeLoading = false
          })
      } else {
        await this.apiService
          .get(`unidade/list/${this.institution.id}`, null, true, false)
          .then((response) => {
            this.unidades = response.content
            this.unidadeLoading = false
          })
          .catch(() => {
            this.unidadeLoading = false
          })
      }
    },

    async getUsersByType() {
      this.responsibleLoading = true

      await this.apiService
        .get(`user/byType/${this.institution.id}`, null, true, false)
        .then((response) => {
          this.responsibleUsers = response.content
          this.responsibleLoading = false
        })
        .catch(() => {
          this.responsibleLoading = false
        })
    },

    setRequestNowDate() {
      this.automation.requestDate = !this.automation.requestDate
        ? new Date()
        : this.automation.requestDate
    },

    back() {
      this.$router.go(-1)
    },

    submit() {
      if (!this.$refs.form.validate()) return

      if (!this.automation.requestDate) {
        this.requestDateTimeError = true
        return
      }

      this.automation.requestDate = moment(this.automation.requestDate).format(
        'yyyy-MM-DDThh:mm:ss'
      )

      this.automation.institutionId = this.institution.id

      this.loading = true
      if (this.editing) {
        this.apiService
          .put('orderAutomation/edit', this.automation)
          .then(() => {
            this.$toast.success('Automação atualizada com sucesso!')
            this.$router.push('/orderAutomation')
            this.loading = false
            this.confirmDialog = false
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.apiService
          .post('orderAutomation/add', this.automation)
          .then(() => {
            this.$toast.success('Automação adicionada com sucesso!')
            this.$router.push('/orderAutomation')
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },

  watch: {
    searchEquipmentSerial(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipmentSerial(value)
    },

    searchEquipment(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipment(value)
    },

    searchEquipmentPropertyCode(value) {
      value &&
        value !== this.equipmentId &&
        this.querySelectionsEquipments(value)
    },
  },
}
</script>

<style scoped>
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}
</style>
